import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import {
  LinearProgress,
  Grid,
  TextField,
  Button,
  Typography,
  Checkbox,
  Paper,
  Divider,
  FormControlLabel,
  Link,
} from "@mui/material";
import {
  Settings,
  DefaultSettings,
  CodeDetails,
  DefaultCodeDetails,
} from "../../../shared/types";
import { Notification } from "../../../shared/components";
import {
  fetchCodeDetails,
  sendPayForwardRequest,
} from "../../../shared/utilities/actions";
import * as consts from "../../../shared/utilities/consts";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

export interface MainProps {}

export const Main = ({}: MainProps): JSX.Element => {
  const [codeDetails, setCodeDetails] = useState<CodeDetails>({
    ...DefaultCodeDetails,
  });
  const [busy, setBusy] = useState<boolean>(true);
  const [status, setStatus] = useState<string>("pending");
  const [notification, setNotification] = useState({ message: "", type: "" });
  const [invalidEmail, setInvalidEmail] = useState<boolean>(false);
  const [invitation, setInvitation] = useState<{
    from: string;
    to: string;
    message: string;
    email: string;
  }>({ from: "", to: "", message: "", email: "" });

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let themeId = fetchCodeDetails(codeDetails.themeId, setCodeDetails);
      setBusy(false);
    };
    fetchData();
  }, []);

  const isEmailValid = (email: string): boolean => {
    if (email.length == 0) {
      return false;
    } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return false;
    } else {
      return true;
    }
  };

  const renderForm = () => {
    switch (status) {
      case "input":
        return (
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="Name"
                fullWidth={true}
                InputProps={{
                  className: "tb_paper_input",
                }}
                label="From"
                helperText="Let your friend know where this came from."
                value={invitation.from}
                onChange={(event) => {
                  setInvitation({ ...invitation, from: event.target.value });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth={true}
                InputProps={{
                  className: "tb_paper_input",
                }}
                multiline={true}
                rows={5}
                helperText="Include a message with the gift."
                label="Message"
                value={invitation.message}
                onChange={(event) => {
                  setInvitation({ ...invitation, message: event.target.value });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth={true}
                InputProps={{
                  className: "tb_paper_input",
                }}
                label="Your Friend's Name"
                value={invitation.to}
                onChange={(event) => {
                  setInvitation({ ...invitation, to: event.target.value });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth={true}
                InputProps={{
                  className: "tb_paper_input",
                }}
                required={true}
                error={invalidEmail}
                helperText={
                  invalidEmail ? "Please enter a valid email address" : ""
                }
                label="Your Friend's Email"
                value={invitation.email}
                onChange={(event) => {
                  setInvitation({ ...invitation, email: event.target.value });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                fullWidth={true}
                className="tb_action_button"
                onClick={async () => {
                  if (isEmailValid(invitation.email)) {
                    await sendPayForwardRequest(
                      codeDetails.code,
                      codeDetails.email,
                      codeDetails.name,
                      invitation.email,
                      invitation.from,
                      invitation.to,
                      invitation.message
                    );
                    setStatus("thankYou");
                    setNotification({
                      message: "Request successfully submitted",
                      type: consts.ALERT_TYPE_SUCCESS,
                    });
                  } else {
                    setInvalidEmail(true);
                    setNotification({
                      message: "Invalid email",
                      type: consts.ALERT_TYPE_ERROR,
                    });
                  }
                }}
              >
                Send Your $50 Gift Now
              </Button>
            </Grid>
          </Grid>
        );
      case "thankYou":
        return (
          <Grid item xs={12}>
            <Typography>
              Thank you for making a difference for the causes you care about!
              🎉
            </Typography>
          </Grid>
        );
      default:
        return (
          <Grid item xs={12}>
            <Button
              className="tb_action_button"
              variant="outlined"
              fullWidth={true}
              onClick={() => {
                setStatus("input");
              }}
            >
              Send a FREE $50 Charity Gift Card
            </Button>
          </Grid>
        );
    }
  };

  return (
    <Paper sx={{ padding: "16px", maxWidth: "550px", width: "100%" }}>
      {codeDetails.code && (
        <Grid item container xs={12} spacing={2}>
          <Notification
            message={notification.message}
            type={notification.type}
            open={notification.message.length > 0}
            onDismiss={() => {
              setNotification({ message: "", type: "" });
            }}
          />
          {busy && (
            <Grid item xs={12}>
              <LinearProgress />
            </Grid>
          )}
          {renderForm()}
        </Grid>
      )}
    </Paper>
  );
};
